import { useContext } from "react";
import { ContextState } from "../../../layout";

const UserPop = ({ courseAttendee }) => {
    const { contextReducer } = useContext(ContextState);

    console.log("courseAttendee", courseAttendee)
    return (
        <div className="courses_user_counter_table_model">
            <div className="table_responsive fullWidth vert_scroll" style={{ marginTop: '2rem' }}>
                <table className="table">
                    <thead>
                        <tr>
                            <th><p>Email</p></th>
                            <th><p>First Name</p></th>
                            <th><p>Last Name</p></th>
                            {contextReducer.cms_type === 'skill-up' && <>
                                <th><p>Alumni</p></th>
                                <th><p>Membership</p></th>
                            </>}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            courseAttendee?.map(data => (
                                <tr>
                                    <td>{data.email}</td>
                                    <td>{data.first_name}</td>
                                    <td>{data.last_name}</td>
                                    {contextReducer.cms_type === 'skill-up' && <>
                                        <td>{data.email.includes('@alumni.usc.edu') ? "Yes" : "No"}</td>
                                        <td>{data.membership}</td>
                                    </>}
                                </tr>
                            )
                            )
                        }
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default UserPop